import { serverFetch } from "@core/server";

export function fetchSprTextList(vid) {
  return serverFetch("sprs/text", {
    queryParams: { vid }
  });
}

export function fetchSprText(vid, idText) {
  return serverFetch(`sprs/text/${vid}/${idText}`);
}

export function createSprText(bodyData) {
  return serverFetch("sprs/text", {
    method: "POST",
    bodyData
  });
}

export function saveSprText(bodyData) {
  return serverFetch("sprs/text", {
    method: "PUT",
    bodyData
  });
}

export function importSprText(bodyData) {
  return serverFetch("sprs/text/import", { method: "POST", bodyData });
}

export function deleteSprText(vid, idText) {
  return serverFetch(`sprs/text/${vid}/${idText}`, {
    method: "DELETE"
  });
}
